module.exports = __webpack_public_path__ + "static/icons/icon-piste-map-8f70ebfe2e71828c9653244672921aa6.svg";